/**
 * Client-side helpers: trim, strip nulls / C0 controls, clamp length before API calls.
 * Does not replace server validation; pairs with server sanitize middleware.
 */
import DOMPurify from "dompurify";

const C0_EXCEPT_WHITESPACE = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g;

export function sanitizePlainText(
  input: string,
  maxLen = 500_000,
  options?: { trim?: boolean },
): string {
  if (typeof input !== "string") return "";
  let s = input.replace(/\0/g, "").replace(C0_EXCEPT_WHITESPACE, "");
  const trim = options?.trim !== false;
  if (trim) s = s.trim();
  if (s.length > maxLen) s = s.slice(0, maxLen);
  return s;
}

/** Strip dangerous bytes from password; do not trim (spaces may be intentional). */
export function sanitizePasswordForWire(input: string, maxLen = 1024): string {
  if (typeof input !== "string") return "";
  return input
    .replace(/\0/g, "")
    .replace(C0_EXCEPT_WHITESPACE, "")
    .slice(0, maxLen);
}

export function normalizeEmailClient(input: string): string {
  if (typeof input !== "string") return "";
  return input.replace(/\0/g, "").trim().toLowerCase().slice(0, 320);
}

/**
 * Sanitizes markdown content using DOMPurify to prevent XSS.
 */
export function sanitizeMarkdown(content: string): string {
  if (typeof content !== "string") return "";
  return DOMPurify.sanitize(content, {
    ALLOWED_TAGS: [
      "p", "br", "strong", "em", "h1", "h2", "h3", "h4", "h5", "h6",
      "ul", "ol", "li", "code", "pre", "blockquote", "hr", "table",
      "thead", "tbody", "tr", "th", "td", "a", "img"
    ],
    ALLOWED_ATTR: ["href", "src", "alt", "title", "class", "target", "rel"]
  });
}
